module.exports = __webpack_public_path__ + "img/lachssteakmithintergrund.12248f77.jpg";